import { Observable } from 'rxjs/Observable';
import { translateService } from 'services/TranslateService';

let alertComponent: IAlertComponent;

export interface IAlertComponent {
  show(message: string, title: string, confirmation?: boolean, code?: string): Observable<boolean>;
}

export function setup(compoent: IAlertComponent): void {
  alertComponent = compoent;
}

export function showAlert(message: string, title: string = 'Alerta'): Observable<boolean> {
  return Observable
    .of(true)
    .switchMap(() => alertComponent.show(message, title, false));
}

export function showError(err: any): Observable<boolean> {
  const code: string = (err && err.data && err.data.code) || '';

  const errorData = translateService.getErrorData(code);

  return Observable
    .of(true)
    .switchMap(() => alertComponent.show(errorData.message, errorData.title || 'Ops!', false, code));
}

export function showConfirm(message: string, title: string = 'Confirmação'): Observable<boolean> {
  return Observable
    .of(true)
    .switchMap(() => alertComponent.show(message, title, true));
}


// WEBPACK FOOTER //
// ./src/shared/services/dialog.ts